<ng-container>
  <div class="dcp-custom-form dcp p-2">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="mb-0">Add Pharmacist Signature</h2>
      <button class="border-0 bg-white" (click)="this.dialogRef.close()" [disabled]="savedSignature" type="button">
        <img alt="close icon" src="assets/images/icons/grey_cross_icon.png" />
      </button>
    </div>
    <div class="form-container">
      <!-- SignaturePad Canvas -->
      <canvas #signaturePad class="full-width-canvas" width="500" height="300"></canvas>
      <p>Date: {{currentDate}}</p>
      <!-- Manual Signature Upload -->
      <input type="file" (change)="onFileChange($event)" accept="image/*" id="fileInput" style="display: none" />
      <div class="modal-footer">
        <div class="left-buttons">
          <!-- "Upload sign" button -->
          <button *ngIf="consultation_programe_id !== 0 || consultation_programe_id !== 1 || consultation_programe_id !== 2" class="custom-btn" (click)="uploadSign()">
            Upload sign
          </button>

          <button class="btn btn-primary mr-2" [disabled]="savedSignature" (click)="saveSignature()">
            {{ savedSignature ? "Update... " : "Add " }}
          </button>

          <button class="btn btn-outline-primary mr-2" (click)="clearSignature()">
            Clear
          </button>
          <!-- <button class="btn btn-outline-primary mr-2" (click)="downloadSignature()">
            Download
          </button> -->
          <button class="btn btn-outline-primary" (click)="closoPopup()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-container>
